import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['repository', 'gitFolder']

  connect() {
    if (this.repositoryTarget.value) {
      this.loadGitFolders()
    }
  }

  repositoryChanged() {
    this.loadGitFolders()
  }

  loadGitFolders() {
    const repositoryId = this.repositoryTarget.value
    const currentValue = this.gitFolderTarget.value

    this.gitFolderTarget.innerHTML = '<option value="">Select a folder</option>'

    if (!repositoryId) return

    fetch(`/fabric-workspaces/git-folders?repository_id=${encodeURIComponent(repositoryId)}`, {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(response => response.json())
      .then(data => {
        data.git_folders.forEach(folder => {
          const option = document.createElement('option')
          option.value = folder.id
          option.textContent = folder.name
          if (String(folder.id) === String(currentValue)) {
            option.selected = true
          }
          this.gitFolderTarget.appendChild(option)
        })
      })
      .catch(error => {
        console.error('Error fetching git folders:', error)
      })
  }
}
